import React, { Suspense, useEffect } from "react";
import Layout from "./components/layout/Layout";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Teams from "./pages/teams/TeamsPage";
import Agents from "./pages/agents/AgentsPage";
import Knowledge from "./pages/knowledge/KnowledgePage";
import Tools from "./pages/tools/ToolsPage";
import Guardrails from "./pages/guardrails/GuardrailsPage";
import NotFound from "./pages/NotFound/NotFound";

function App() {
  const loadPage = (children: React.ReactNode) => {
    return <Layout>{children}</Layout>;
  };
  useEffect(() => {
    console.warn = () => {};
    console.error = () => {};
  }, []);

  return (
    <Router>
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="/" element={<Navigate to="/teams" replace />} />
          <Route path="/teams" element={loadPage(<Teams />)} />
          <Route path="/agents" element={loadPage(<Agents />)} />
          <Route path="/knowledge" element={loadPage(<Knowledge />)} />
          <Route path="/tools" element={loadPage(<Tools />)} />
          <Route path="/guardrails" element={loadPage(<Guardrails />)} />
          <Route path="*" element={loadPage(<NotFound />)} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
